// @material-ui/core
import { TextField } from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { withRouter } from "react-router";
import { compose } from "redux";
import { pageStyles, withPage } from "../../library/pages";

class Apps extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired
  };

  state = {
    newApp: {
      name: "",
      clientId: ""
    }
  };

  handleChange = name => event => {
    this.setState(
      {
        newApp: { ...this.state.newApp, [name]: event.target.value }
      },
      () => {
        this.props.handleChange(this.state.newApp);
      }
    );
  };

  render() {
    return (
      <React.Fragment>
        <TextField
          id="name"
          label="Name"
          value={this.state.newApp.name}
          margin="normal"
          fullWidth={true}
          onChange={this.handleChange("name")}
        />

        <TextField
          id="clientId"
          label="Client ID"
          value={this.state.newApp.clientId}
          margin="normal"
          fullWidth={true}
          onChange={this.handleChange("clientId")}
        />
      </React.Fragment>
    );
  }
}

export default compose(withRouter, withStyles(pageStyles), withPage)(Apps);



// WEBPACK FOOTER //
// ./src/pages/apps/Apps.js